// Unpublished Work © 2023 Deere & Company.

import { CategoryKey, ToggleKey } from "../../pages/featureToggles/constants";
import {
  FeatureToggleDetail,
  FeatureToggleStatus,
} from "../../pages/featureToggles/types";
import { axios } from "../index";

export const FeatureToggleApi = {
  getFeatureToggles: (
    url: string,
    accessToken: string
  ): Promise<FeatureToggleDetail[]> =>
    axios
      .getWithRetries<FeatureToggleDetail[]>(`${url}/feature-toggles/v1`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => res.data),
  saveFeatureToggles: (
    url: string,
    data: FeatureToggleDetail,
    accessToken: string
  ): Promise<FeatureToggleDetail> =>
    axios
      .putWithRetries<FeatureToggleDetail>(`${url}/feature-toggles/v1`, data, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => res.data),
  getAllFeatureToggleStatus: (
    url: string,
    accessToken: string,
    country: string,
    branch?: string,
    accounts?: string
  ): Promise<FeatureToggleStatus[]> =>
    axios
      .getWithRetries<FeatureToggleStatus[]>(
        `${url}/feature-toggles/v1/all/status`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            country,
            branch,
            accounts,
          },
        }
      )
      .then((res) => res.data),

  getFeatureToggleStatus: async (
    url: string,
    accessToken: string,
    categoryKey: CategoryKey,
    toggleKey: ToggleKey,
    country: string,
    account?: string,
    branch?: string
  ) =>
    axios
      .getWithRetries<FeatureToggleStatus>(
        `${url}/feature-toggles/v1/${categoryKey}/toggle/${toggleKey}/status`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            country,
            branch,
            accounts: account,
          },
        }
      )
      .then((res) => res.data),
};
